import React from "react";
import {
  Box,
  FormControlLabel,
  FormControl,
  Checkbox,
  Typography,
  Button,
  TablePagination,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
  Divider,
} from "@material-ui/core";
import { withSnackbar } from "notistack";
import { withStyles } from "@material-ui/core/styles";
import stations, { measurements } from "./airQualityStation";

//Obtiene la url del proxie para los casos donde se invocan servicios por http
const proxieURL = process.env.REACT_APP_PROXIE;

//Nombre de las capas del mapa que utiliza el componente
var layerNames = {
  CalidadAire: "airQualityCDMXIMECA",
};

//Estilos del componente
const useStyles = (theme) => ({
  info: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
});

//Componenete de Calidad del Aire
class AirQuality extends React.Component {
  //Contructor que denfine el estado inicial del componente
  constructor(props) {
    super(props);
    this.state = {
      estaciones: false,
      estacionesData: [],
      page: 0,
      rowsPerPage: 10,
      loaded: false,
      loading: false,
      header: {},
      loadedData: false,
    };
  }

  //Establece el estado del cintillo al desmontar el compoenente
  componentWillUnmount() {
    this.props.setMarqueeState(false, "");
  }

  //Establece los datos por default al fallar la petición al servicio
  getDummyPointData = () => {
    this.props.enqueueSnackbar("Error al obtener los datos del servicio", {
      variant: "warning",
    });
    this.setState({
      estacionesData: [],
      loading: false,
      loaded: false,
    });
  };

  //Abre otra ventana con la url del sitio indicado
  openSite = (site) => {
    window.open(site, "_blank");
  };

  //Ejecuta una petición a la url del servicio de calidad del aire
  getPoints = async (tipo) => {
    let layer = this.props.moduleLayers.find(
      (l) => l.nombre === layerNames.CalidadAire
    );
    var serviceUrl = `${proxieURL}${layer.url}`;

    this.setState({ loading: true });
    const res = await fetch(serviceUrl, {
      method: "GET",
      timeout: 8000,
    }).catch((err) => {
      this.getDummyPointData();
    });
    if (res) {
      if (res.status === 200) {
        let data = await res.text();
        let header = {};

        try {
          let parser = new DOMParser();
          let xmlDoc = parser.parseFromString(data, "text/xml");
          data =
            xmlDoc.getElementsByTagName("string")[0].childNodes[0].nodeValue;
          data = JSON.parse(data);
          header = {
            fecha: data?.Measurements?.fecha,
            hora: data?.Measurements?.hora,
            parametro: data?.Measurements?.parametro,
            riesgo: data?.Measurements?.Riesgo,
            color: data?.Measurements?.Color,
            recomendacion1_IAS: data?.Measurements?.recomendacion1_IAS,
            recomendacion2_IAS: data?.Measurements?.recomendacion2_IAS,
            recomendacion1_IAS_app: data?.Measurements?.recomendacion1_IAS_app,
            recomendacion2_IAS_app: data?.Measurements?.recomendacion2_IAS_app,
          };
        } catch (e) {
          this.getDummyPointData();
        }

        this.setState(
          {
            estacionesData: data,
            loaded: true,
            loading: false,
            header,
            loadedData: true,
          },
          () => {
            if (data.airdata?.information[0]?.pcaa) {
              this.props.setMarqueeState(
                true,
                data.airdata?.information[0]?.pcaa
              );
            }
            this.drawPoints(layerNames.CalidadAire, data);
          }
        );
      } else {
        this.getDummyPointData();
      }
    }
  };

  //Renderea en mapa los puntos y plantilla de información obtenidos del serivicio de calidad del aire
  drawPoints = (layerId, data) => {
    const { esri } = this.props;
    let objLayer = this.props.mapView.getLayer(layerId);
    objLayer.clear();

    let datos = data.Measurements?.IAS_e?.concentraciones;
    let statusStations = data.Measurements?.IAS?.IAS_MAX;
    if (datos?.length > 0) {
      datos.forEach((station) => {
        let _station = stations.find((e) => e.id === station.value);
        var point = new esri.Point(
          _station.location.lon,
          _station.location.lat
        );

        var empty = false;

        var concentracionContent =
          "<div><h3 style='margin-bottom:0;'>Contaminantes</h3><h5 style='margin-top:0;'>Datos de concentración</h5><ul>";

        if (!empty) {
          concentracionContent +=
            "<li>Hora de lectura: <span class='dataValue'>" +
            data.Measurements?.fecha +
            "</span></li>";
          Object.entries(station).forEach(([key, value]) => {
            if (key !== "value") {
              let _data = value.split("*");
              let uom = measurements.find(
                (e) => e.pollutant.toUpperCase() === key.toUpperCase()
              );
              concentracionContent +=
                "<li><span class='mayusculas'>" +
                key +
                "</span>: <span class='dataValue'>" +
                (_data[0] === ""
                  ? "Sin datos"
                  : _data[0] + " " + (uom ? uom.unit : "")) +
                "</span></li>";
            }
          });
        } else {
          concentracionContent += "<li>Estación en mantenimiento</li>";
        }

        concentracionContent += "</ul></div>";

        if (layerId === "airQualityCDMXConcentration") {
        } else if (layerId === "airQualityCDMXIMECA") {
          var airConditionConcentracion = {
            title: "Estación: " + _station.name,
            content: concentracionContent,
          };
          let status = statusStations.find((e) => e.value === station.value);
          let icono = "";
          switch (status.riesgo) {
            case "BUENA":
              icono = "./imgs/SEDEMA/b.png";
              break;
            case "ACEPTABLE":
              icono = "./imgs/SEDEMA/r.png";
              break;
            case "MALA":
              icono = "./imgs/SEDEMA/m.png";
              break;
            case "MUY MALA":
              icono = "./imgs/SEDEMA/mm.png";
              break;
            case "EXTREMADAMENTE MALA":
              icono = "./imgs/SEDEMA/em.png";
              break;
            case "PELIGROSA":
              icono = "./imgs/SEDEMA/p.png";
              break;
            case "SIN DATOS O EN MANTENIMIENTO":
              icono = "./imgs/SEDEMA/mantenimiento.png";
              break;
            default:
              icono = "./imgs/SEDEMA/mantenimiento.png";
              break;
          }
          var graphicConcentracion = new esri.Graphic(
            point,
            new esri.PictureMarkerSymbol(icono, 25, 25),
            null,
            new esri.InfoTemplate(airConditionConcentracion)
          );
          objLayer.add(graphicConcentracion);
        }
      });
    }
  };

  //Maneja el evento al dar click en los checkbox
  handleChangeCheck = (e) => {
    const { name, checked } = e.target;
    this.setState({ [name]: checked }, () => {
      if (name === "estaciones") {
        let layer = this.props.mapView.getLayer(layerNames.CalidadAire);
        layer.setVisibility(checked);
        if (checked) {
          this.getPoints();
        } else {
          this.props.setMarqueeState(false, "");
        }
      }
    });
  };

  //Obtiene la fecha actual
  getToday = () => {
    var meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
    var today = new Date();
    var month = today.getMonth();
    return (
      today.getDate() + " de " + meses[month] + " del " + today.getFullYear()
    );
  };

  //Obtiene el horario actual
  getHours = () => {
    var today = new Date();
    return today.getHours() + " horas";
  };

  //Ejectura un acercamiento en el mapa dado un punto
  zoomIn = (p) => {
    const { lat, lon } = p.location;
    var point = new this.props.esri.Point(lon, lat);
    this.props.mapView.centerAndZoom(point, 14);
  };
  //Renderea en el panel los puntos y plantilla de información obtenidos del serivicio de calidad del aire
  renderPoints() {
    let data = this.state.estacionesData;
    let rowsPerPage = this.state.rowsPerPage;
    let page = this.state.page;

    let from = page * rowsPerPage;
    let to = page * rowsPerPage + rowsPerPage;
    let currentRows = [];
    let total = 0;
    let info = null;
    if (data?.airdata?.stations) {
      total = data?.airdata?.stations?.station.length;
      currentRows = data.airdata.stations.station.slice(from, to);
      info = data.airdata.information[0];
    }
    let i = 0;
    const { classes } = this.props;
    const { loaded, loading } = this.state;
    if (loading)
      return (
        <Box mt={1} mb={4}>
          <Typography variant="overline">Cargando datos...</Typography>{" "}
        </Box>
      );
    else
      return (
        <Box mt={1} mb={4}>
          {loaded && total > 0 && (
            <Box p={1} mb={2} component={Paper} className={classes.info}>
              <Typography variant="overline" style={{ fontWeight: "bolder" }}>
                {this.getToday()} Corte de las {this.getHours()}
              </Typography>
              <Box>
                <Typography display="inline" variant="caption">
                  Calidad del aire:{" "}
                </Typography>
                <Typography
                  display="inline"
                  variant="caption"
                  style={{ color: info.colorimeca }}
                >
                  {info.indiceimeca}
                </Typography>
              </Box>

              <Box>
                <Typography display="inline" variant="caption">
                  índice:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {info.valormeca}
                </Typography>
              </Box>

              <Box>
                <Typography display="inline" variant="caption">
                  Contaminante:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {info.parametro}
                </Typography>
              </Box>
              <Box>
                <Typography display="inline" variant="caption">
                  Nivel de radiación UV:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {info.calificativoUV}
                </Typography>
              </Box>

              <Box>
                <Typography display="inline" variant="caption">
                  Índice de radiación UV:{" "}
                </Typography>
                <Typography display="inline" variant="caption">
                  {info.indiceradiacion}
                </Typography>
              </Box>
            </Box>
          )}
          {loaded && total > 0 && (
            <Typography variant="button">
              Estaciones y su registro de concentración de contaminantes
            </Typography>
          )}
          {currentRows.map((p) => {
            let enMantenimiento =
              p.measurements.measurement.filter((m) => m.value).length === 0;
            let j = 0;
            return (
              <Box p={1} mb={2} key={i++} component={Paper}>
                <Box>
                  <Button onClick={() => this.zoomIn(p)}>
                    <Typography
                      variant="overline"
                      style={{ fontWeight: "bolder" }}
                    >
                      {p.name} ({p.id})
                    </Typography>
                  </Button>
                  {!enMantenimiento && (
                    <Box ml={2}>
                      <Typography
                        display="inline"
                        variant="caption"
                        color="primary"
                      >
                        Hora de lectura:{" "}
                      </Typography>
                      <Typography display="inline" variant="caption">
                        {p.measurements.measurement[0].time.split("|")[1]}
                      </Typography>
                    </Box>
                  )}
                </Box>
                {!enMantenimiento ? (
                  p.measurements.measurement
                    .filter((m) => m.value)
                    .map((m) => {
                      return (
                        <Box ml={2} key={i * 1000 + j++}>
                          <Typography
                            display="inline"
                            variant="caption"
                            color="primary"
                          >
                            {m.pollutant}:{" "}
                          </Typography>
                          <Typography display="inline" variant="caption">
                            {m.value} {m.unit}
                          </Typography>
                        </Box>
                      );
                    })
                ) : (
                  <Box ml={2}>
                    <Typography
                      display="inline"
                      variant="overline"
                      color="primary"
                    >
                      Estación en mantenimiento
                    </Typography>
                  </Box>
                )}
              </Box>
            );
          })}
          {total > 0 && (
            <TablePagination
              rowsPerPageOptions={[10, 20]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={(e, newPage) => {
                this.setState({ page: newPage });
              }}
              onChangeRowsPerPage={(e) => {
                this.setState({ rowsPerPage: parseInt(e.target.value, 10) });
              }}
            />
          )}
        </Box>
      );
  }

  //Render del resumen de calidad del aire
  renderResumen() {
    const {
      fecha,
      hora,
      parametro,
      riesgo,
      color,
      recomendacion1_IAS,
      recomendacion2_IAS,
      recomendacion1_IAS_app,
      recomendacion2_IAS_app,
    } = this.state.header;
    return (
      <Box
        component={Paper}
        p={1}
        style={{
          backgroundColor: color,
        }}
      >
        <Box>
          <Typography variant="caption">Fecha: </Typography>
          <Typography variant="caption">{fecha}</Typography>
        </Box>
        <Box>
          <Typography variant="caption">Hora: </Typography>
          <Typography variant="caption">{hora}</Typography>
        </Box>

        <Box>
          <Typography variant="caption">Parámetro: </Typography>
          <Typography variant="caption">{parametro}</Typography>
        </Box>
        <Box>
          <Typography variant="caption">Riesgo: </Typography>
          <Typography variant="caption">{riesgo}</Typography>
        </Box>
        <Box mt={1}>
          <Typography variant="caption" style={{ fontWeight: "bold" }}>
            Recomendaciones grupos sensibles:{" "}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption">
            <section dangerouslySetInnerHTML={{ __html: recomendacion1_IAS }} />
          </Typography>
        </Box>

        <Box mt={1}>
          <Typography variant="caption" style={{ fontWeight: "bold" }}>
            Recomendaciones población en general:{" "}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption">
            <section dangerouslySetInnerHTML={{ __html: recomendacion2_IAS }} />
          </Typography>
        </Box>
      </Box>
    );
  }
  //Renderea el contenido estático del componente
  render() {
    const { estaciones, loadedData } = this.state;
    return (
      <Box style={{ width: "100%" }}>
        <Box align="center">
          <a
            href="http://www.aire.cdmx.gob.mx/default.php"
            color="primary"
            target="_blank"
            rel="noreferrer"
          >
            <Typography variant="caption">(SEDEMA)</Typography>
          </a>
        </Box>

        <Box>
          <FormControl component="fieldset" size="small" fullWidth>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={estaciones}
                  onChange={this.handleChangeCheck}
                  name="estaciones"
                  color="primary"
                />
              }
              label={
                <Typography variant="caption">Índice y Estaciones</Typography>
              }
            />
          </FormControl>
        </Box>
        <Box my={2}>{loadedData && this.renderResumen()}</Box>
        {loadedData && (
          <Box>
            <TableContainer component={Paper}>
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell colSpan={2}>
                      Índice de la calidad del aire
                    </TableCell>
                    <TableCell>Condición</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/b.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        0-50
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box></Box>
                        Buena
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/r.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        51-100
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        Regular
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/m.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        101-150
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        Mala
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/mm.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        151-200
                      </Typography>
                    </TableCell>

                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        Muy mala
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/em.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline" noWrap>
                        <Box mr={1}></Box>
                        201-300
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        Extremadamente mala
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/p.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline" noWrap>
                        <Box mr={1}></Box>
                        {">300"}
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>
                        Peligrosa
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      component="th"
                      scope="row"
                      style={{ width: 20, paddingRight: 0 }}
                    >
                      <img
                        alt="simbologia"
                        src="./imgs/SEDEMA/mantenimiento.png"
                        style={{ width: 20 }}
                      ></img>
                    </TableCell>
                    <TableCell>
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>M
                      </Typography>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Typography variant="caption" display="inline">
                        <Box mr={1}></Box>Mantenimiento
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
        {estaciones && this.renderPoints()}
      </Box>
    );
  }
}

export default withStyles(useStyles)(withSnackbar(AirQuality));
